import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Button from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Button';
import { Popover } from '@material-ui/core';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import Typography from 'Components/UI/Typography';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Spacer from 'Components/UI/Spacer';
import { Paper } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';

const styles = theme => ({
  root: {
    backgroundColor: 'white',
  },
  popoverRoot: {
    maxWidth: '600px',
    padding: theme.spacing(2),
  },
  icon: {
    color: theme.palette.facet.accentBlue,
  },
  button: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
  },
  filters: {
    display: 'flex',
    flexDirection: 'column',
  },
});

const FilterGroup = ({
  children,
  classes,
  className,
  groupName,
  onApply,
  ApplyFiltersButtonProps,
  ...rest
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleApply = () => {
    onApply();
    setAnchorEl(null);
  };

  return (
    <Paper elevation={1} className={classNames(classes.root, className)} {...rest}>
      <Button onClick={handleClick} className={classes.button}>
        <Typography variant="h6" color="primary">{groupName}</Typography>
        <Spacer />
        {open ? <KeyboardArrowUp className={classes.icon} /> : <KeyboardArrowDown className={classes.icon} />}
      </Button>
      <Popover
        classes={{
          paper: classes.popoverRoot,
        }}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <div className={classes.filters}>
          {children}
        </div>
        <div className={classes.actions}>
          <Button
            test={'bulk-communication-filter-apply-button'}
            color={'secondary'}
            variant={'contained'}
            onClick={handleApply}
            {...ApplyFiltersButtonProps}
          >
            {'Apply'}
          </Button>
        </div>
      </Popover>
    </Paper>
  );
};


FilterGroup.propTypes = {
  children: PropTypes.node.isRequired,
  groupName: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  onApply: PropTypes.func.isRequired,
  ApplyFiltersButtonProps: PropTypes.object,
};

FilterGroup.defaultProps = {
  className: '',
  ApplyFiltersButtonProps: {},
};

export default withStyles(styles)(FilterGroup);
